const _excluded = ["className", "href", "title", "children", "linktype", "dataCy", "ariaLabel", "onClick", "linksTarget", "openInSameTab", "style", "onMouseEnter", "onMouseLeave", "ariaLabelledbyId", "ctaLeftIcon", "ctaRightIcon", "isDetSite", "isSharedCh", "colorText", "color", "colorActive", "rtl"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import './RouterLink.css';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { canUseDOM, getGlobalDictionaryTerm, get, getColorByTheme, getPageThemeColors } from '../../../utils';
import clsx from 'clsx';
const RouterLink = _ref => {
  let {
      className = '',
      href,
      title = '',
      children,
      linktype = 'internal',
      dataCy = '',
      ariaLabel = '',
      onClick,
      linksTarget,
      openInSameTab = false,
      style = {},
      onMouseEnter,
      onMouseLeave,
      ariaLabelledbyId,
      ctaLeftIcon,
      ctaRightIcon,
      isDetSite = null,
      isSharedCh = null,
      colorText,
      color,
      colorActive,
      rtl = false
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const sitecoreContext = useSitecoreContext();
  let finalLabel = ariaLabel ? ariaLabel : title;
  const conditionalProps = finalLabel ? {
    'aria-label': finalLabel
  } : {};
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const pageThemeColors = useMemo(() => getPageThemeColors(isVdsite), [isVdsite]);
  const isDetSiteFlag = typeof isDetSite === 'object';
  const isSharedChFlag = typeof isSharedCh === 'object';
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : pageThemeColors.primary;
  const colorByTheme = useMemo(() => {
    return {
      color: getColorByTheme(color ? color : ''),
      selectedPrimaryColor: getColorByTheme(selectedPrimaryColor)
    };
  }, [color, selectedPrimaryColor]);
  const isPrimaryBtn = className.includes('btn-primary');
  const styleThemeHexColor = color ? {
    '--btn-color': color,
    '--btn-active-color': colorActive,
    '--btn-text-color': colorText ? colorText : colorByTheme.color
  } : {
    '--btn-color': selectedPrimaryColor,
    '--btn-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : pageThemeColors.primary_active,
    '--btn-text-color': colorByTheme.selectedPrimaryColor
  };
  const commonStyles = !isDetSiteFlag || !isSharedChFlag ? className ? clsx(isDetSite ? "cpldwky" : clsx`
                ${isSharedCh ? "c1fql9k5" : "c1lbftwu"}
              `, isPrimaryBtn ? clsx`
               ${!isSharedChFlag ? "cfrlbuh" : "c12nx3a7"}
              ` : clsx`
               ${!isSharedChFlag ? "c1nxdf5n" : "cyzid75"}
              `) : clsx(isDetSite ? "cgxqrl3" : "c1x11je3") : "cb98ysy";
  const rtlStyles = !isDetSiteFlag ? "r1jrbjhf" : "r166bfgr";
  const ltrStyles = "l19iybc6";
  if (ariaLabelledbyId) {
    conditionalProps['aria-labelledby'] = ariaLabelledbyId;
  }
  if (linktype && linktype !== 'internal' || href && href.startsWith('http') || linksTarget === '_blank') {
    const finalTarget = linksTarget ? linksTarget : openInSameTab ? '_self' : '_blank';
    if (finalTarget === '_blank') {
      const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || 'Opens in a new window';
      finalLabel = finalLabel ? `${finalLabel} | ${newWindowLabel}` : newWindowLabel;
      conditionalProps['aria-label'] = finalLabel;
    }
    return /*#__PURE__*/React.createElement("a", _extends({
      className: `${clsx(commonStyles, rtl ? rtlStyles : ltrStyles)} ${className}`,
      href: href,
      target: finalTarget,
      rel: "noopener noreferrer",
      "data-cy": dataCy,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      style: _objectSpread(_objectSpread({}, style), styleThemeHexColor),
      onClick: () => {
        if (onClick) {
          onClick();
        }
      }
    }, otherProps, conditionalProps), ctaLeftIcon ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: ctaLeftIcon
      },
      className: "ctaLeftIcon"
    }) : /*#__PURE__*/React.createElement(React.Fragment, null), children, ctaRightIcon ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: ctaRightIcon
      },
      className: "ctaRightIcon"
    }) : /*#__PURE__*/React.createElement(React.Fragment, null));
  }
  return /*#__PURE__*/React.createElement(Link, _extends({
    className: `${clsx(commonStyles, rtl ? rtlStyles : ltrStyles)} ${className}`,
    to: href,
    "data-cy": dataCy,
    style: _objectSpread(_objectSpread({}, style), styleThemeHexColor),
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: () => {
      if (onClick) {
        onClick();
      }
    }
  }, otherProps, {
    ref: otherProps.ref
  }, conditionalProps), ctaLeftIcon ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: ctaLeftIcon
    },
    className: "ctaLeftIcon"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null), children, ctaRightIcon ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: ctaRightIcon
    },
    className: "ctaRightIcon"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null));
};
export default RouterLink;